import { nameValidator } from '../fields';

const config = { mandatory: true };

const islConstraints = {
  displayName: nameValidator(config)
};

export default islConstraints;
